<template>
  <div>
    <v-card-text>
      <v-select
        v-if="this.geoClassOptions !== null"
        v-model="selectedGeoClass"
        :items="translateGeoClass"
        clearable
        :label="this.$i18n.t('geographic_scale')"
        @change="geoChoice()"
      >
      </v-select>
      <v-switch
        v-if="
          this.geoOptions !== null &&
            this.selectedGeoClass !== 'france_metropolitaine_et_drom' &&
            this.selectedGeoClass !== 'france_metropolitaine' &&
            this.selectedGeoClass !== 'drom' &&
            this.selectedGeoClass !== undefined
        "
        v-model="geoFilter"
        :label="$i18n.t('select_geo_groups')"
        @change="selectFilter()"
      ></v-switch>
      <v-autocomplete
        v-if="
          this.geoOptions !== null &&
            this.selectedGeoClass !== 'france_metropolitaine_et_drom' &&
            this.selectedGeoClass !== 'france_metropolitaine' &&
            this.selectedGeoClass !== 'drom' &&
            this.selectedGeoClass !== undefined &&
            this.geoFilter
        "
        v-model="selectedGeo"
        :items="translateGeo"
        chips
        multiple
        clearable
        deletable-chips
        :label="this.$i18n.t('geographic_scope')"
        @change="geoChoice()"
      >
      </v-autocomplete>
      <v-checkbox
        v-if="
          this.geoOptions !== null &&
            this.selectedGeoClass !== 'france_metropolitaine_et_drom' &&
            this.selectedGeoClass !== 'france_metropolitaine' &&
            this.selectedGeoClass !== 'drom' &&
            this.selectedGeoClass !== undefined &&
            this.geoFilter
        "
        dense
        v-model="allSelected"
        :label="$i18n.t('select_all')"
        @click="selectAll()"
      ></v-checkbox>
      <v-alert
        type="info"
        color="info"
        outlined
        v-if="
          this.geoOptions !== null &&
            (this.selectedGeoClass == 'france_metropolitaine_et_drom' ||
              this.selectedGeoClass == 'drom' ||
              this.selectedGeoClass == 'regdom_nouv' ||
              this.selectedGeoClass == 'regdom' ||
              this.selectedGeoClass == 'depdom')
        "
      >
        {{ this.$t("alert.geo_scope_overseas") }}
      </v-alert>
    </v-card-text>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "GeoForm",
  components: {},
  props: {
    lang: {
      type: String,
      required: true,
      default: "fr-FR"
    }
  },
  data: function() {
    return {
      geoClassOptions: null,
      selectedGeoClass: "france_metropolitaine_et_drom",
      geoOptions: null,
      selectedGeo: null,
      geoFilter: false,
      allSelected: false,
      error: null
    };
  },
  computed: {
    translateGeoClass: function() {
      const val = this;
      const res = this.geoClassOptions.map(function(e) {
        if (e !== undefined) {
          return {
            value: e,
            text: val.$i18n.t(e)
          };
        } else {
          return {
            value: e,
            text: e
          };
        }
      });
      return res;
    },
    translateGeo: function() {
      if (this.geoOptions === undefined) {
        return [];
      } else {
        const val = this;
        const res = Object.keys(this.geoOptions).map(function(e) {
          if (e !== undefined) {
            return {
              value: val.geoOptions[e].code,
              text: val.geoOptions[e].code + " - " + val.geoOptions[e].label
            };
          } else {
            return {
              value: e,
              text: e
            };
          }
        });
        return res;
      }
    }
  },
  methods: {
    availableGeoClass: function() {
      this.error = false;
      axios
        .get("bcmd/r/locations", {
          params: {}
        })
        .then(response => {
          this.geoClassOptions = response.data;
        })
        .catch(() => {
          this.error = true;
        });
    },
    availableGeo: function() {
      if (this.selectedGeoClass === undefined) {
        this.geoOptions = [];
        this.selectedGeo = [];
        this.geoFilter = false;
        this.allSelected = false;
      } else {
        this.error = false;
        axios
          .get("bcmd/r/codes_geo", {
            params: {
              scale: this.selectedGeoClass
            }
          })
          .then(response => {
            this.geoOptions = response.data;
            this.selectedGeo = [];
            this.allSelected = false;
          })
          .catch(() => {
            this.error = true;
          });
      }
    },
    selectAll: function() {
      if (this.allSelected) {
        if (this.geoOptions !== undefined) {
          const val = this;
          this.selectedGeo = Object.keys(this.geoOptions).map(function(e) {
            if (e !== undefined) {
              return val.geoOptions[e].code;
            } else {
              return [];
            }
          });
        } else {
          this.selectedGeo = [];
        }
      } else {
        this.selectedGeo = [];
      }
    },
    selectFilter: function() {
      if (!this.geoFilter) {
        this.selectedGeo = [];
      }
    },
    geoChoice: function() {
      this.$emit("update-geo", {
        selectedGeoClass: this.selectedGeoClass, //autre nom possible : scaleGeo
        selectedGeo: this.selectedGeo
      });
      if (this.geoOptions !== undefined) {
        if (this.selectedGeo.length !== Object.keys(this.geoOptions).length) {
          this.allSelected = false;
        } else {
          this.allSelected = true;
        }
      }
      console.log("this.selectedGeoClass :");
      console.log(this.selectedGeoClass);
      console.log("this.selectedGeo :");
      console.log(this.selectedGeo);
      return true;
    }
  },
  beforeMount() {
    console.log("beforeMount : availableGeoClass() + availableGeo()");
    this.availableGeoClass(); // autres noms possibles : geoScope (périmètre/champ/couverture géographique) ou geoScale (échelle géo)
    this.availableGeo(); // autre nom : geographic area(s)
  },
  watch: {
    $props: {
      handler: function() {
        console.log("watch props : availableGeoClass() + availableGeo() + geoChoice()");
        this.availableGeoClass();
        this.availableGeo();
        this.geoChoice();
      },
      deep: true
    },
    selectedGeoClass: function() {
      console.log("watch selectedGeoClass : this.availableGeo()");
      this.availableGeo();
    },
    selectedGeo: function() {
      console.log("watch selectedGeo : this.geoChoice()");
      this.geoChoice();
    }
  }
};
</script>
